import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a8e2928755b8c0014905235_1787716150832_4182268f/evora/src/app/giris/page.tsx");
